/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivExceptionViewmodelGen,
  MrfiktivPageViewModelGen,
  MrfiktivReportControlControllerFindAllParamsGen,
  MrfiktivReportControlViewModelGen
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class ReportControlService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Report Control Service
   * @name ReportControlControllerFindAll
   * @summary Get all forwarded reports
   * @request GET:/report-control/{partnerId}
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivReportControlViewModelGen)[] })`
   * @response `401` `MrfiktivExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `MrfiktivExceptionViewmodelGen` Forbidden.
   * @response `500` `MrfiktivExceptionViewmodelGen` Internal Server Error
   */
  reportControlControllerFindAll = (
    { partnerId, ...query }: MrfiktivReportControlControllerFindAllParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<
      MrfiktivPageViewModelGen & { data?: MrfiktivReportControlViewModelGen[] },
      MrfiktivExceptionViewmodelGen
    >({
      path: `/report-control/${partnerId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
}
